import TileComponent from './Tile';
import OldTile from './Tile.container';
export type { TileProps, TileItem, TILE_TYPE } from './Tile.types';

export { TileComponent };

export default OldTile;
